<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="委托推广"
    width="500px"
    
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">

        <el-form-item label="推广费" prop="money" >  
          <el-input-number v-model="formData.money" :min="1" :max="100" label="推广费"></el-input-number>
        </el-form-item>

        <el-form-item label="分成比例" prop="scale" >  
          <el-input-number v-model="formData.scale" :min="0" :max="100" label="分成比例"></el-input-number>
        </el-form-item>

        <el-form-item label="委托人">
          <!--
            <el-select   placeholder="请选择" :multiple="false" v-model="formData.stage_id">
              <el-option
                  v-for="item in userList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
-->
            <el-input v-model="formData.mobile" placeholder="请输入委托人电话"></el-input>

        </el-form-item>
     
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import {addEntrustApi } from  "@/api/relation/index.js";

export default {
  components: { },

  data() {
    return {
      visible: false,
      userList:[],
      formData: {
          user_app_ids:[],
          mobile:"",
          money:0,
          scale:0,
          stage_id:""
      
      },
       rules: {
            mobile: [
                {required: true, message: '请输入委托人电话', trigger: 'blur'}
            ],
            
            money: [
                {required: true, message: '请输入推广费', trigger: 'blur'}
            ],

            scale: [
                {required: true, message: '请输入佣金比例', trigger: 'blur'}
            ],
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
  
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init(user_app_ids) {
      this.formData.user_app_ids=user_app_ids;
      this.visible = true;
    },

   
    
    
    submit(){
      var that=this;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            addEntrustApi(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }

  .table_form {
    width: 100%;
    height: 68px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 19px;
  section {
    display: flex;
    img {
      width: 43px;
      height: 43px;
      margin-right: 15px;
    }
    div {
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      b {
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 11px;
        margin-right: 20px;
        color: #666;
      }
    }
  }
}
</style>
